import React from 'react';
import { Box, Progress, Flex, Text } from '@chakra-ui/react';

const InlineLoader = ({ message = "", size = "xs", colorScheme = "blue" }) => {
    return (
        <Flex direction="column" w="100%" gap={2}>
            {message && (
                <Text fontSize="xs" color="gray.500" fontWeight="600">
                    {message}
                </Text>
            )}
            <Box w="100%" borderRadius="full" overflow="hidden" bg="white" p={0.5} border="1px solid" borderColor="gray.100">
                <Progress
                    size={size}
                    isIndeterminate
                    colorScheme={colorScheme}
                    borderRadius="full"
                    isAnimated
                />
            </Box>
        </Flex>
    );
};

export default InlineLoader;
